import { useEffect, useRef, useState } from "react";
import { loadPreferencesFromServer, migrateLocalStorageToServer } from "./PreferenceStore";

/**
 * Hook that synchronizes user preferences on app init.
 * 1. Loads server preferences into localStorage cache
 * 2. Migrates legacy localStorage data to server (one-time)
 *
 * Should be called once after the user is authenticated.
 * Both inner functions handle their own errors, so setIsSynced(true) is always reached.
 */
export const usePreferencesSync = (): { isSynced: boolean } => {
    const [isSynced, setIsSynced] = useState(false);
    const syncStarted = useRef(false);

    useEffect(() => {
        if (syncStarted.current) return;
        syncStarted.current = true;

        const sync = async () => {
            await loadPreferencesFromServer();
            await migrateLocalStorageToServer();
            setIsSynced(true);
        };

        sync();
    }, []);

    return { isSynced };
};
